import MerchantApi from '@/api/merchant'

const state = {
  isRequiredNps: false,
  submittedNps: false,
}

const getters = {}

const mutations = {
  SET_REQUIRE_NPS: (state, status) => {
    state.isRequiredNps = status
  },
  SET_SUBMITTED_NPS: (state, status) => {
    state.submittedNps = status
  },
}

const actions = {
  async submitNps({ commit, rootGetters }, data) {
    const merchantId = rootGetters['session/merchantId']
    const orderId = rootGetters['checkout/orderId']
    const dataToBeSent = {
      orderId,
      score: data?.score,
      comment: data?.comment || '',
    }

    try {
      return await MerchantApi.submitNps(merchantId, dataToBeSent)
    } catch (_) {
    } finally {
      commit('SET_SUBMITTED_NPS', true)
    }
  },
  requireNps({ commit }, status) {
    commit('SET_REQUIRE_NPS', status)
    commit('SET_SUBMITTED_NPS', false)
  },
}

export default { namespaced: true, state, getters, mutations, actions }
